export class DosageLevelContentModel {
    public dosageLevelId: number;
    public langId: number;
    public specificDescription: string;
    public comments: string;
    public uses: string;
}